import LicenseLimitedModal, {
  LicenseLimitedModalPropsBase,
} from "@/components/modal/license-limited-modals/license-limited-modal";
import React from "react";
import { duetsLicenseManager } from "@/services/license/license-managers/duets-license-manager";
import { stemSplitterLicenseManager } from "@/services/license/license-managers/stem-splitter-license-manager";

const StemSplitterCountLimitedModal = ({
  licenseName,
}: LicenseLimitedModalPropsBase) => {
  return (
    <LicenseLimitedModal
      licenseName={licenseName}
      upgradeToMessage={"split stems"}
      allowsMessage={""}
      shouldNavigateToPricing={true}
    />
  );
};

export default StemSplitterCountLimitedModal;
